<template>
  <generic-container
    icon="sitemap"
    :title="$t('multimoney organization chart')"
    :configurable="false"
    :show_plus="false"
    :show_back="true"
    @add="add"
    :show_refresh="true"
    @refresh="init"
    :header_buttons="header_buttons"
  >
    <div id="sdbrctxt">
      <div
        class="ui sidebar overlay right menu"
        ref="sidebar"
        style="padding: 10px !important; z-index: 10 !important"
      >
        <div class="ui form" style="width: 100%">
          <staff-search
            style="margin-bottom: 15px"
            @selected="staff_selected"
            ref="staff_search"
          />
          <!-- <div class="field">
            <label for>{{ $t("name") }}</label>
            <input type="text" name="name" v-model="selected_node.name" />
          </div>
          <div class="field">
            <label for>{{ $t("title") }}</label>
            <input type="text" name="title" v-model="selected_node.title" />
          </div> -->
          <div class="ui grid">
            <div class="eight wide column">
              <div
                class="ui fluid mini green icon labeled button"
                @click="apply"
              >
                <i class="check icon"></i>
                {{ $t("apply") }}
              </div>
            </div>
            <div class="eight wide column">
              <div
                class="ui fluid mini red icon labeled button"
                @click="remove"
              >
                <i class="trash icon"></i>
                {{ $t("delete") }}
              </div>
            </div>
            <div class="sixteen wide column" style="padding-top: 0">
              <div
                class="ui fluid mini orange icon labeled right floated button"
                @click="add_below"
              >
                <i class="plus icon"></i>
                {{ $t("add below") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pusher" style="width: 100%; height: 100%">
        <div ref="chart_container" style="width: 100%; height: 100%"></div>
      </div>
    </div>
    <!-- <staff-modal ref="staff_modal" @success="init" /> -->
  </generic-container>
</template>

<script>
import filters from "@/filters";
import StaffSearch from "./StaffSearch.vue";
import { v4 } from "uuid";
import {
  local_api,
  enterprise_setup,
  error_toast,
  success_toast,
} from "@/utils";
import GenericContainer from "@/components/GenericContainer";
// import ConfigureModal from "./configuration_modal/Index.vue";
// import StaffModal from "./staff_modal/Index.vue";
import "orgchart/dist/js/jquery.orgchart";
import "orgchart/dist/css/jquery.orgchart.min.css";

// @ is an alias to /src
export default {
  name: "MultimoneyStaffOrganization",
  components: {
    "generic-container": GenericContainer,
    StaffSearch,
    // StaffModal,
  },
  filters: filters,
  data() {
    return {
      selected_node: {
        id: "",
        name: "",
        staff_id: "",
        staff: undefined,
      },
      ds: {},
      oc: {},
      // configure_modal: ConfigureModal,
      header_buttons: [
        // {
        //   icon: "horse head",
        //   click: this.do_init,
        //   tooltip: this.$t("init"),
        // },
        // {
        //   icon: "blue save",
        //   click: this.do_save,
        //   tooltip: this.$t("save"),
        // },
      ],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    add() {
      // let vm = this;
      // vm.$refs.staff_modal.show_modal();
    },
    calculateTree(node, staff, level) {
      let vm = this;
      // console.log("calculate tree of node", node, "with staff", staff);
      let immediateSubdites = staff.filter((s) => {
        return String(s.immediate_superior_staff_id) == String(node.staff_id);
      });
      return {
        id: v4(),
        name: `${node.first_name} ${node.surname}`,
        description: node.multimoney_staff_job_position.name,
        level: level,
        children: immediateSubdites.map((sbdt) => {
          return vm.calculateTree(sbdt, staff, level + 1);
          // return {
          //   id: v4(),
          //   name: `${node.first_name} ${node.surname}`,
          //   level: level + 1,
          //   children: vm.calculateTree(sbdt, staff, level + 1),
          // };
        }),
      };
    },
    prepareDS(staff) {
      let vm = this;
      // console.log("preparing ds from staff", staff);
      // Finding all that have no immediate superior
      let chiefs = staff.filter((s) => {
        return !s.immediate_superior_staff_id;
      });
      let trees = chiefs.map((c) => {
        c.tree = vm.calculateTree(c, staff, 0);
        return c;
      });

      // console.log("trees", trees);
      return new Promise((resolve /* reject */) => {
        if (trees.length == 1) {
          resolve(trees.find((x) => x).tree);
        } else {
          resolve({
            id: v4(),
            name: "",
            description: vm.$t("headmaster"),
            level: 0,
            children: trees.map((sbdt) => {
              return vm.calculateTree(sbdt, staff, 1);
            }),
          });
        }
      });
    },
    init() {
      let vm = this;
      local_api(vm, "post", "/multimoney_staff/organization/do-get", {})
        .then((org) => {
          vm.prepareDS(org)
            .then((ds) => {
              vm.ds = ds;
              vm.initChart();
            })
            .catch((err) => {
              error_toast(err);
            });
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    apply() {
      let vm = this;
      let targetNode = vm.searchTree(vm.ds, vm.selected_node.id);
      // console.log("selected node", this.selected_node);
      if (targetNode) {
        targetNode.name = vm.selected_node.name;
        if (
          vm.selected_node.staff &&
          vm.selected_node.staff.multimoney_staff_job_position
        )
          targetNode.description =
            vm.selected_node.staff.multimoney_staff_job_position.name;
        targetNode.staff_id = vm.selected_node.staff_id;
      }

      vm.initChart();
      window.jQuery(vm.$refs.sidebar).sidebar("hide");
    },
    remove() {
      this.removeNode(null, this.selected_node.id);

      this.initChart();
    },
    do_init() {
      this.ds = {
        id: v4(),
        name: "",
        description: "",
        staff_id: "",
      };
      this.initChart();
    },
    do_save() {
      let vm = this;
      local_api(vm, "post", "/multimoney_staff/organization/do-save", {
        d: vm.ds,
      })
        .then((/* org */) => {
          success_toast(vm.$t("organization saved"));
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    add_below() {
      let targetNode = this.searchTree(this.ds, this.selected_node.id);
      if (targetNode) {
        if (targetNode.children) {
          targetNode.children.push({
            id: v4(),
            name: this.$t("new"),
            description: this.$t("new"),
            staff_id: "",
          });
        } else {
          targetNode.children = [
            {
              id: v4(),
              name: this.$t("new"),
              description: this.$t("new"),
              staff_id: "",
            },
          ];
        }
      }

      this.initChart();
    },
    searchTree(element, matchingTitle) {
      if (element.id == matchingTitle) {
        return element;
      } else if (element.children != null) {
        var i;
        var result = null;
        for (i = 0; result == null && i < element.children.length; i++) {
          result = this.searchTree(element.children[i], matchingTitle);
        }
        return result;
      }
      return null;
    },
    removeNode(element, matchingTitle) {
      let vm = this;
      if (!element) {
        if (this.ds.id == matchingTitle) this.ds = {};
        else this.removeNode(this.ds, matchingTitle);
      } else if (element.children != null) {
        let idx = element.children.findIndex((c) => c.id == matchingTitle);
        if (idx >= 0) {
          element.children.splice(idx, 1);
          window.jQuery(vm.$refs.sidebar).sidebar("hide");
        } else {
          for (let i = 0; i < element.children.length; i++) {
            this.removeNode(element.children[i], matchingTitle);
          }
        }
      }
    },
    initChart() {
      setTimeout(() => {
        let vm = this;
        window.jQuery(vm.$refs.chart_container).empty();
        let oc = window.jQuery(vm.$refs.chart_container).orgchart({
          data: vm.ds,
          nodeContent: "description",
          nodeTitle: "name",
          chartClass: "edit-state",
          // exportButton: true,
          exportFilename: "SportsChart",
          draggable: true,
          pan: true,
          zoom: true,
          // nodeTemplate: vm.nodeTemplate,
          dropCriteria: function ($draggedNode, $dragZone, $dropZone) {
            if (
              $draggedNode.find(".content").text().indexOf("manager") > -1 &&
              $dropZone.find(".content").text().indexOf("engineer") > -1
            ) {
              return false;
            }
            return true;
          },
          createNode: function () {},
        });

        // oc.$chartContainer.on("touchmove", function (event) {
        //   event.preventDefault();
        // });

        // oc.$chartContainer.on("click", ".node", function (event) {
        //   event.preventDefault();
        //   event.stopPropagation();
        //   let $this = window.jQuery(this);
        //   let data = $this.data("nodeData");

        //   vm.selected_node.id = data.id;
        //   vm.selected_node.name = data.name;
        //   vm.selected_node.staff_id = data.staff_id;

        //   // console.log("showing sidebarx", data);

        //   setTimeout(() => {
        //     if (data.staff_id) vm.$refs.staff_search.set_staff(data.staff_id);
        //     window
        //       .jQuery(vm.$refs.sidebar)
        //       .sidebar({
        //         dimPage: false,
        //         context: window.jQuery("#sdbrctxt"),
        //         onHide() {
        //           vm.$refs.staff_search.clean();
        //         },
        //         onVisible() {
        //           console.log("is visible");
        //         },
        //       })
        //       .sidebar("show");
        //   }, 200);
        // });

        // oc.$chartContainer.on("click", ".orgchart", function () {
        //   window.jQuery(vm.$refs.sidebar).sidebar("hide");
        // });

        vm.oc = oc;
      }, 200);
    },
    staff_selected(staff) {
      let vm = this;
      vm.selected_node.name = `${staff.first_name} ${staff.surname}`;
      vm.selected_node.staff = staff;
      vm.selected_node.staff_id = staff.staff_id;
    },
  },
  created() {},
  mounted() {
    let vm = this;
    vm.init();
  },
  watch: {},
};
</script>

<style scoped>
.orgchart .node .content {
  height: unset !important;
}

.node i.oci-leader {
  margin-left: 5px !important;
}

.orgchart .node .title {
  background-color: rgba(92, 153, 219, 0.91);
}

.orgchart .node .content {
  border-color: rgba(92, 153, 219, 0.91);
}

.orgchart .lines .rightLine,
.orgchart .lines .leftLine {
  border-color: rgba(92, 153, 219, 0.91);
}

.orgchart .lines .downLine {
  background-color: rgba(92, 153, 219, 0.91);
}

.orgchart {
  background-image: linear-gradient(
      90deg,
      rgba(10, 10, 10, 0.05) 10%,
      rgba(0, 0, 0, 0) 10%
    ),
    linear-gradient(rgba(10, 10, 10, 0.05) 10%, rgba(0, 0, 0, 0) 10%);
  width: 100%;
  height: 100%;
}
</style>
